import * as React from "react";
import { NotificationBar as NotificationBar$1 } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
const CmsNotificationBar = ({ content, theme = "dark" }) => {
  const { title, description, links } = content;
  const [link] = useBloomreachLinks(links);
  if (!title && !description) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    NotificationBar$1,
    {
      title,
      description,
      theme,
      link: { ...link, label: link?.label ?? "" }
    }
  );
};
const NotificationBar = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsNotificationBar);
export {
  CmsNotificationBar,
  NotificationBar as default
};
//# sourceMappingURL=NotificationBar.js.map
